import React from 'react';
import { CollapsibleAccordionTitleView } from './view';
import { styles } from './styles';

export class CollapsibleAccordionTitle extends React.Component {
  render() {
    return <CollapsibleAccordionTitleView {...this.props} styles={styles} />;
  }
}
